/* PL Decals — site behavior
 * Header: sticky/scrolled state, mega panels (hover), mobile menu, accordion.
 * Plus: progress bar, scroll reveal.
 */
(function () {
  "use strict";

  /* ── Sticky scrolled state ─────────────────────────────── */
  function updateNavScrolled() {
    const nav = document.getElementById("nav");
    if (!nav) return;
    if (window.scrollY > 10) nav.classList.add("scrolled");
    else nav.classList.remove("scrolled");
  }
  window.addEventListener("scroll", updateNavScrolled, { passive: true });

  /* ── Mega panels (desktop hover) ───────────────────────── */
  function setupMega() {
    const items = document.querySelectorAll(".nmi[data-mega]");
    let activeItem = null;
    let closeTimer = null;

    function openPanel(item) {
      clearTimeout(closeTimer);
      if (activeItem && activeItem !== item) closePanel(activeItem);
      const panel = document.getElementById(item.dataset.mega);
      if (!panel) return;
      item.classList.add("active");
      panel.classList.add("open");
      activeItem = item;
    }
    function closePanel(item) {
      if (!item) return;
      const panel = document.getElementById(item.dataset.mega);
      if (panel) panel.classList.remove("open");
      item.classList.remove("active");
      if (activeItem === item) activeItem = null;
    }
    function closeAll() {
      if (activeItem) closePanel(activeItem);
    }

    items.forEach((item) => {
      item.addEventListener("mouseenter", () => openPanel(item));
      item.addEventListener("mouseleave", () => {
        closeTimer = setTimeout(() => closePanel(item), 140);
      });
    });

    document.querySelectorAll(".mega-wrap .mega").forEach((panel) => {
      panel.addEventListener("mouseenter", () => clearTimeout(closeTimer));
      panel.addEventListener("mouseleave", () => {
        closeTimer = setTimeout(closeAll, 140);
      });
    });

    document.addEventListener("click", (e) => {
      if (!e.target.closest(".nmi") && !e.target.closest(".mega")) closeAll();
    });
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") closeAll();
    });
  }

  /* ── Mobile menu (global, called from onclick) ─────────── */
  window.openMenu = function () {
    const m = document.getElementById("mob-menu");
    if (!m) return;
    m.classList.add("open");
    document.body.style.overflow = "hidden";
  };
  window.closeMenu = function () {
    const m = document.getElementById("mob-menu");
    if (!m) return;
    m.classList.remove("open");
    document.body.style.overflow = "";
    // collapse any open submenus
    document.querySelectorAll(".mob-sub.open").forEach((s) => s.classList.remove("open"));
    document.querySelectorAll(".mob-it.open").forEach((s) => s.classList.remove("open"));
  };
  window.toggleMob = function (id) {
    const item = document.getElementById(id);
    if (!item) return;
    const sub = item.querySelector(".mob-sub");
    if (!sub) return;
    const isOpen = item.classList.contains("open");
    // close siblings (one-at-a-time accordion)
    document.querySelectorAll(".mob-it.open").forEach((s) => {
      if (s !== item) {
        s.classList.remove("open");
        const ss = s.querySelector(".mob-sub");
        if (ss) ss.classList.remove("open");
      }
    });
    item.classList.toggle("open", !isOpen);
    sub.classList.toggle("open", !isOpen);
  };

  // ESC closes mobile menu
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      const m = document.getElementById("mob-menu");
      if (m && m.classList.contains("open")) window.closeMenu();
    }
  });

  /* ── Top progress bar (optional element #progress) ─────── */
  const progressEl = document.getElementById("progress");
  if (progressEl) {
    window.addEventListener(
      "scroll",
      () => {
        const h = document.documentElement;
        const denom = h.scrollHeight - h.clientHeight;
        progressEl.style.width = denom > 0 ? (window.scrollY / denom) * 100 + "%" : "0%";
      },
      { passive: true }
    );
  }

  /* ── Scroll reveal observer ────────────────────────────── */
  const plIO = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add("visible");
          plIO.unobserve(e.target);
        }
      });
    },
    { threshold: 0.06 }
  );
  function observeAll() {
    document.querySelectorAll(".reveal, .stagger").forEach((el) => {
      if (!el.classList.contains("visible")) plIO.observe(el);
    });
  }

  /* ── ATC loading state (all product pages) ─────────────── */
  document.addEventListener('submit', function (e) {
    if (e.defaultPrevented) return; // blocked by inline validation (e.g. size check)
    const btn = e.target && e.target.querySelector && e.target.querySelector('#atc-btn');
    if (!btn) return;
    btn.disabled = true;
    btn.innerHTML = '<span style="opacity:.65">Adding to cart…</span>';
  });

  /* ── Sticky ATC bar (product pages only) ──────────────── */
  function initStickyAtc() {
    var nativeBtn = document.getElementById('atc-btn');
    if (!nativeBtn) return;

    var titleEl = document.querySelector('.p-title');
    // Primary source: #total-display; fallback: #atc-price (inside native btn)
    var priceEl = document.getElementById('total-display') ||
                  document.getElementById('atc-price');

    // Build bar
    var bar = document.createElement('div');
    bar.id = 'sticky-atc-bar';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="satc-info">' +
        '<div class="satc-name">' + (titleEl ? titleEl.textContent.trim() : '') + '</div>' +
        '<div class="satc-price money" id="satc-price">' + (priceEl ? priceEl.textContent.trim() : '') + '</div>' +
      '</div>' +
      '<button type="button" class="satc-btn" id="satc-btn">' +
        'Add to Cart <span class="btn-arr">→</span>' +
      '</button>';
    document.body.appendChild(bar);

    // Helper — always reads live text from the source element
    function syncPrice() {
      var sp = document.getElementById('satc-price');
      if (sp && priceEl) sp.textContent = priceEl.textContent.trim();
    }

    // Sync when variant JS updates #total-display (childList + characterData)
    if (priceEl) {
      new MutationObserver(syncPrice).observe(priceEl, {
        childList: true, subtree: true, characterData: true
      });
    }

    // Sync when a currency switcher app updates prices on the page.
    // Most switchers dispatch 'currency:changed'; Shopify Markets reloads
    // the page entirely so no handling is needed there.
    document.addEventListener('currency:changed', syncPrice);

    // Mirror disabled / loading state from native button
    new MutationObserver(function () {
      var sb = document.getElementById('satc-btn');
      if (!sb) return;
      sb.disabled = nativeBtn.disabled;
    }).observe(nativeBtn, { attributes: true, attributeFilter: ['disabled'] });

    // Click delegates to native button — all existing validation fires
    document.getElementById('satc-btn').addEventListener('click', function () {
      if (!nativeBtn.disabled) nativeBtn.click();
    });

    // Show once native button leaves viewport (scrolled past)
    new IntersectionObserver(function (entries) {
      var inView = entries[0].isIntersecting;
      bar.classList.toggle('satc-visible', !inView);
      bar.setAttribute('aria-hidden', String(inView));
    }, { threshold: 0.5 }).observe(nativeBtn);
  }

  /* ── Collection filter toggle (mobile compact bar) ─────── */
  function setupFilterToggle() {
    document.querySelectorAll(".filter-toggle").forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = "1";
      btn.addEventListener("click", function () {
        var id = btn.getAttribute("aria-controls");
        var pane = id ? document.getElementById(id) : null;
        var isOpen = btn.getAttribute("aria-expanded") === "true";
        btn.setAttribute("aria-expanded", String(!isOpen));
        if (pane) pane.classList.toggle("open", !isOpen);
      });
    });
  }

  /* ── Clickable product cards ───────────────────────────── */
  function setupCardClicks() {
    if (window.__plCardClicks) return;
    window.__plCardClicks = true;
    document.addEventListener("click", function (e) {
      var card = e.target.closest(".pcard");
      if (!card) return;
      // Let genuine controls (links, buttons, form fields) handle their own clicks
      if (e.target.closest("a, button, input, textarea, select, label")) return;
      // Don't hijack an active text selection
      if (window.getSelection && String(window.getSelection())) return;
      var link = card.querySelector("a[href]");
      if (!link) return;
      if (e.metaKey || e.ctrlKey) {
        window.open(link.href, "_blank");
      } else {
        window.location.href = link.href;
      }
    });
  }

  /* ── Init ──────────────────────────────────────────────── */
  function init() {
    updateNavScrolled();
    setupMega();
    observeAll();
    initStickyAtc();
    setupFilterToggle();
    setupCardClicks();
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  window.addEventListener("load", observeAll);

  // Customizer support: re-init when the header section is reloaded
  document.addEventListener("shopify:section:load", (e) => {
    if (!e.target) return;
    if (e.target.querySelector && e.target.querySelector("#nav")) {
      setupMega();
      updateNavScrolled();
    }
    observeAll();
    setupFilterToggle();
  });
})();
